var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"textbox",class:['form-control',_vm.size ? 'form-control-'+_vm.size:''],attrs:{"id":_vm.name,"type":"number","step":_vm.step,"min":_vm.min,"max":_vm.max,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }